import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { ChromePicker } from "react-color";
import "./styles.less";
export const ColorSelect = (props) => {
  const { color, setColor } = props;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };
  const onChange = (color) => {
    setColor(color.hex);
  };
  return (
    <div
      className={classnames("color-select-picker", {
        active: displayColorPicker,
      })}
    >
      <div className="color-select-picker-warp" onClick={handleClick}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span className="color-pattern" style={{ background: color }}></span>
          <span onClick={handleClick}>{color}</span>
        </div>
        <i className="icon authing-icon authing-arrow-right-s-line icon-style"></i>
      </div>
      <div
        className="color-picker"
        onDragstart={(e) => {
          e.stopPropagation();
        }}
        onDrag={(e) => {
          e.stopPropagation();
        }}
        onDragEnd={(e) => {
          e.stopPropagation();
        }}
      >
        {displayColorPicker ? (
          <>
            <div
              className="cover"
              onClick={() => {
                setDisplayColorPicker(false);
              }}
            ></div>
            <ChromePicker onChange={onChange} color={color} />
          </>
        ) : null}
      </div>
    </div>
  );
};
